import { Component, ViewChild,Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ReportsService } from "../../api/api/reports.service";
import { FacilitiesService, Facility } from "../../core/facilities/facilities.service";
import { MedicalRecordOptions } from "../../api/model/medicalRecordOptions";
import MedicalRecordEnum = MedicalRecordOptions.MedicalRecordEnum;
import { ReportResident } from "../../api/model/reportResident";
import { AbstractDownloadFileContentComponent } from '../../shared/download-file-content/abstract-download-file-content.component';

@Component({
    /* Component for displaying a Report Row. */
    selector: 'my-leave-of-absence-report-modal',
    styleUrls: ['leave-of-absence-report-modal.component.scss'],
    templateUrl: 'leave-of-absence-report-modal.component.html'
})

export class LeaveOfAbsenceReportModal extends AbstractDownloadFileContentComponent {

    @ViewChild('recordsModal', {static: false}) public recordsModal: ModalDirective;

    @Output()
    singleModalWasClicked:EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor( private reportService: ReportsService, private facilityService: FacilitiesService){
        super();
        this.initialResidentId = "";
    }
    searchText:string;

    filteredResidents: ReportResident[]=[];
    allPossibleResidents: ReportResident[]=[];

    selectedResident: ReportResident;
    title: string = 'Generate Leave of Absence Form';

    private initialResidentId;

    printMonographs: boolean;
    hideSpinner: boolean = true;

    selectResident(resident: ReportResident){
        if(this.selectedResident) {
            this.selectedResident.IsSelected = false;
        }

        resident.IsSelected = true;
        this.selectedResident = resident;
    }

    searchResidents(value: string){
        this.filteredResidents = this.allPossibleResidents.filter(r=>
        {
            let lowerCaseName = r.Name.toLowerCase();
            let lowerSearch = value.toLowerCase();
            return lowerCaseName.indexOf(lowerSearch)>=0;
        });
    }

    getResidentById(residentId: string){
        let resident : ReportResident = this.allPossibleResidents
            .find( (f) => { return f.ResidentId == residentId} );
        return resident;
    }

    showForPatient(patientId) {
        this.reportService.reportsGetResidentsForModal(this.facilityService.selectedAsOrgList[0]).subscribe((result) =>
        {
            this.allPossibleResidents = result;
            this.filteredResidents = result;
            this.recordsModal.show();
        });
    }

    show() {
        this.reportService.reportsGetResidentsForModal(this.facilityService.selectedAsOrgList[0]).subscribe((result) =>
        {
            this.allPossibleResidents = result;
            this.filteredResidents = result;
            if (this.initialResidentId != "" && this.initialResidentId != null){
                let resident = this.getResidentById(this.initialResidentId);
                this.initialResidentId = "";
                this.selectResident(resident);
                let name = resident.Name;
                this.searchText = name;
                this.searchResidents(name);
            }
            this.recordsModal.show();
        });
        this.printMonographs = false;
    }

    showWithResidentSelected(residentId) {
        this.initialResidentId = residentId;
        this.show();
    }

    closeModal(){
        this.allPossibleResidents = [];
        this.searchText='';
        this.selectedResident = null;
        this.printMonographs = false;
        this.filteredResidents = [];
        this.hideSpinner = true;
        this.recordsModal.hide();
        this.singleModalWasClicked.emit(false);
        this.ngOnDestroy();
    }

    canGenerateReport(): boolean{
        return this.hideSpinner && this.selectedResident !== undefined && this.selectedResident !== null;
    }

    generatePDF(){
        this.hideSpinner = false;
        this.reportService.reportsGetGeneratedLOA(this.facilityService.selectedAsOrgList[0], this.selectedResident.ResidentId, this.printMonographs).subscribe(
            (result) => {
                this.downloadFile(result, 'LeaveofAbsenceForm.pdf');
                this.closeModal();
            }
        );
    }
}
